export class OptionOffer {
  is: number;

  site: string;

  code: string;
  activated_only_once: boolean;

  amount: number;
  amount_gbp: number;

  created_at: Date;
  updated_at: Date;
  price_offer: any;
  activated = false;
}



// WEBPACK FOOTER //
// /app/src/app/entities/option-offer.entity.ts